import { Translations } from '../types/localization.types';

/**
 * English translations for PDF Form Designer
 */
export const en: Translations = {
  elements: {
    textInput: 'Text Input',
    radioButton: 'Radio Button',
    checkbox: 'Checkbox',
    signature: 'Qualified E-Signature',
    digitalSignature: 'Digital Signature',
    biometricSignature: 'Biometric Signature',
    initials: 'Initials',
    text: 'Text',
    attachmentsList: 'Attachments List'
  },

  buttons: {
    save: 'Save Changes',
    cancel: 'Cancel',
    delete: 'Delete',
    deleteAll: 'Delete All Initials',
    addToOtherPages: 'Add to Other Pages',
    clearAll: 'Clear All',
    edit: 'Edit'
  },

  modal: {
    editElement: 'Edit {type} Element',
    properties: 'Properties'
  },

  fields: {
    name: 'Name',
    readOnly: 'Read Only',
    required: 'Required',
    placeholder: 'Placeholder',
    defaultValue: 'Default Value',
    fontSize: 'Font Size',
    fontFamily: 'Font Family',
    fontWeight: 'Font Weight',
    textColor: 'Text Color',
    backgroundColor: 'Background Color',
    borderColor: 'Border Color',
    borderWidth: 'Border Width',
    groupName: 'Group Name',
    value: 'Value',
    selectedValue: 'Selected Value',
    label: 'Label',
    checked: 'Checked',
    buttonColor: 'Button Color',
    checkColor: 'Check Color',
    text: 'Text',
    textAlign: 'Text Align',
    angle: 'Angle (degrees)',
    italic: 'Italic',
    underline: 'Underline',
    bold: 'Bold',
    normal: 'Normal',
    lighter: 'Lighter',
    left: 'Left',
    center: 'Center',
    right: 'Right',
    signatureMethod: 'Signature Method',
    certificateInfo: 'Certificate Info',
    timestampRequired: 'Timestamp Required',
    deviceInfo: 'Device Info',
    pressureSensitive: 'Pressure Sensitive',
    velocityTracking: 'Velocity Tracking',
    distanceFromRight: 'Distance From the Right Side (PDF points)',
    distanceFromBottom: 'Distance From the Bottom (PDF points)',
    // Attachments list specific fields
    listDisplay: 'List Display',
    showFileNames: 'Show File Names',
    showFileSizes: 'Show File Sizes',
    listStyle: 'List Style',
    listStyleNone: 'None (Plain)',
    listStyleNumbers: 'Numbers (1, 2, 3)',
    textFormatting: 'Text Formatting',
    spacingLayout: 'Spacing & Layout',
    lineHeight: 'Line Height',
    lineHeightHelp: 'Spacing multiplier (1.0 = tight, 2.0 = double-spaced)',
    indentation: 'Indentation (points)',
    indentationHelp: 'Left indent for each attachment line',
    styling: 'Visual Styling'
  },

  signatureMethods: {
    pki: 'PKI Certificate',
    adobe: 'Adobe Sign',
    docusign: 'DocuSign'
  },

  signers: {
    title: 'Signers',
    noSigners: 'No signers added yet.',
    addSignersMessage: 'Add signers externally to enable form elements.',
    activeIndicator: 'Active',
    clickToActivate: 'Click to activate'
  },

  tooltips: {
    disabled: '(Disabled)',
    deleteElement: 'Delete element',
    editElement: 'Edit element properties',
    placeElement: 'Click on PDF to place element',
    fontSize: 'Font Size',
    fontFamily: 'Font Family',
    textColor: 'Text Color',
    italic: 'Italic',
    underline: 'Underline'
  },

  dialogs: {
    switchSignerConfirm: 'This element belongs to {name} ({email}). Switch to this signer?'
  },

  placeholders: {
    enterText: 'Enter text...',
    certificateDetails: 'Certificate details',
    deviceInfo: 'Capture device information',
    abc: 'ABC',
    textInput: 'Text Input',
    signature: 'Signature',
    digitalSignature: 'Digital Signature',
    text: 'Text',
    attachmentsList: 'Attachments List',
    attachmentsCapacity: '({count} attachment(s) can fit)'
  },

  fonts: {
    arial: 'Arial',
    timesNewRoman: 'Times New Roman',
    helvetica: 'Helvetica',
    courier: 'Courier'
  },

  errors: {
    elementNameEmpty: 'Element name cannot be empty',
    elementNameDuplicate: 'Element name "{name}" is already used by another element. Names must be globally unique.',
    selectedValueEmpty: 'Selected value cannot be empty',
    selectedValueDuplicate: 'Duplicate option value "{value}" already exists in group "{group}"',
    radioGroupNameConflict: 'Radio group name "{name}" is already used by another signer. Each signer must have unique group names.',
    invalidConfigVersion: 'Invalid configuration: Only version 3.0.0 is supported. Please ensure your configuration uses exact coordinates with page dimensions.',
    noSignersInConfig: 'Invalid configuration: No signers found. All configurations must include at least one signer.',
    noActiveSignerInConfig: 'Invalid configuration: No active signer specified.',
    activeSignerNotInList: 'Invalid configuration: Active signer ID does not exist in signers list.',
    elementsWithoutSigner: 'Invalid configuration: {count} elements found without signer assignments.',
    elementsReferenceInvalidSigners: 'Invalid configuration: {count} elements reference signers that don\'t exist.',
    partialConfigMissingSigners: 'Configuration loaded partially. Please add the following signers to complete loading:\n{signerIds}',
    invalidElementDimensions: 'Warning: Configuration contains {count} element(s) with invalid dimensions (upside-down): {ids}. These have been auto-corrected.',
    zeroSizedElements: 'Invalid configuration: {count} element(s) have zero dimensions and cannot be displayed.'
  }
};
